import { createAsyncThunk } from '@reduxjs/toolkit';
import { _priceUrls } from '@custom/Utils/constants/apiUrls';

interface PriceQueryParams {
  modality?: string;
  studyRegion?: string;
  search?: string;
  page?: number;
  limit?: number;
  from?: string;
}

const getPrice = createAsyncThunk(
  'getPrice',
  async (params?: PriceQueryParams) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');

      const query = new URLSearchParams();
      if (params?.modality) query.append('modality', params.modality);
      if (params?.studyRegion) query.append('studyRegion', params.studyRegion);
      if (params?.search) query.append('search', params.search);
      if (params?.page !== undefined) query.append('page', String(params.page));
      if (params?.limit !== undefined) query.append('limit', String(params.limit));
      if (params?.from) query.append('from', params.from);

      const url = `${_priceUrls.get}?${query.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch price data');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default getPrice;
